import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import Popup from '../../Popup';
import s from './DialogPopup.scss';
var DialogPopupLayout = /** @class */ (function (_super) {
    tslib_1.__extends(DialogPopupLayout, _super);
    function DialogPopupLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogPopupLayout.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, onClose = _a.onClose, rootClassName = _a.rootClassName, contentClassName = _a.contentClassName, headerClassName = _a.headerClassName, withCloseButton = _a.withCloseButton, footerClassName = _a.footerClassName, children = _a.children, title = _a.title, headerExtras = _a.headerExtras, footer = _a.footer, footerExtras = _a.footerExtras, titleClassName = _a.titleClassName;
        return (React.createElement(Popup, { className: classnames(s['root'], rootClassName), contentClassName: contentClassName, closeBtnClassName: s['close-btn'], isOpen: isOpen, withCloseButton: withCloseButton, onRequestClose: onClose },
            React.createElement("div", { className: classnames(s['header'], headerClassName) },
                React.createElement("div", { className: classnames(s['title'], titleClassName) }, title),
                headerExtras),
            children,
            footer && (React.createElement("div", { className: classnames(s['footer'], footerClassName) },
                footerExtras,
                footer))));
    };
    return DialogPopupLayout;
}(React.Component));
export { DialogPopupLayout };
export default DialogPopupLayout;
//# sourceMappingURL=DialogPopupLayout.js.map